import { getConfig } from 'utils/config';
import assetsBase from './base/assets';
import assetsIonos from './ionos/assets';
import assetsSDS from './sds/assets';
import assetsBechtle from './bechtle/assets';
import assetsItz from './itzbund/assets';

const assets = {
  sds: assetsSDS,
  ionos: assetsIonos,
  itzbund: assetsItz,
  bechtle: assetsBechtle,
  base: assetsBase,
  default: assetsBase,
};


const getAssets = () => {
  const { theme = '' } = getConfig() || {};
  return assets[theme] || assets.default;
};

export { getAssets };
